import { render, staticRenderFns } from "./UserPairModal.vue?vue&type=template&id=3de87a25"
import script from "./UserPairModal.vue?vue&type=script&lang=js"
export * from "./UserPairModal.vue?vue&type=script&lang=js"
import style0 from "./UserPairModal.vue?vue&type=style&index=0&id=3de87a25&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports